import { useState, useEffect } from 'react'
import DopaLogo from './DopaLogo'

const EncouragementBlock = () => {
  const [currentMessage, setCurrentMessage] = useState(0)

  const encouragementMessages = [
    {
      title: "You are safe here",
      message: "This space holds you gently. There's no rush, no pressure. Just breathe."
    },
    {
      title: "Solitude can heal",
      message: "Sometimes the most caring thing we can do is simply be with ourselves."
    },
    {
      title: "You're doing enough",
      message: "By being here, by taking this moment, you're already caring for yourself."
    },
    {
      title: "Rest is sacred",
      message: "Your need for quiet is valid. Honor what your heart is asking for."
    },
    {
      title: "You belong here",
      message: "Exactly as you are, in this moment, you belong in this peaceful space."
    },
    {
      title: "Gentle presence",
      message: "Sometimes healing happens not through doing, but through simply being."
    },
    {
      title: "Your pace is perfect",
      message: "There's no timeline for feeling better. Go as slowly as you need."
    }
  ]

  useEffect(() => {
    // Cycle through messages every 45 seconds
    const interval = setInterval(() => {
      setCurrentMessage(prev => (prev + 1) % encouragementMessages.length)
    }, 45000)

    return () => clearInterval(interval)
  }, [])

  const message = encouragementMessages[currentMessage]

  return (
    <div className="bg-peach-50/20 dark:bg-peach-900/20 backdrop-blur-sm rounded-3xl border border-peach-100/20 dark:border-peach-700/20 p-6 sm:p-8 max-w-md mx-auto">
      <div className="text-center">
        <div className="mx-auto mb-4">
          <DopaLogo size="sm" className="justify-center" withText={false} />
        </div>
        <h3 className="text-peach-600 dark:text-peach-300 font-light text-base sm:text-lg mb-3 sm:mb-4 leading-relaxed">
          {message.title}
        </h3>
        <p className="text-peach-500 dark:text-peach-400 font-light text-sm sm:text-base leading-relaxed">
          {message.message}
        </p>
      </div>
      
      {/* Subtle progress dots */}
      <div className="flex justify-center space-x-2 mt-4 sm:mt-6">
        {encouragementMessages.map((_, index) => (
          <div
            key={index}
            className={`w-1 h-1 rounded-full transition-all duration-1000 ${
              index === currentMessage ? 'bg-peach-400 dark:bg-peach-300' : 'bg-peach-200/40 dark:bg-peach-700/40'
            }`}
          />
        ))}
      </div>
    </div>
  )
}

export default EncouragementBlock